<template>
  <div class="col-xl-6 mb-3 mb-xl-0" v-loading="loading">
    <card header-classes="bg-transparent">
      <div slot="header" class="row align-items-center">
        <div class="col">
          <h6 class="text-uppercase text-muted ls-1 mb-1">
            Faturamento Por Serviço
          </h6>
        </div>
        <div class="col">
          <el-select
            v-model="month"
            placeholder="Selecione  uma opção"
            @change="initBigChart()"
          >
            <el-option
              v-for="row of options"
              :key="row.key"
              :label="row.label"
              :value="row.key"
            ></el-option>
          </el-select>
        </div>
      </div>
      <el-table :data="tableData" stripe style="width: 100%">
        <el-table-column
          prop="service"
          :label="$t('servico')"
        ></el-table-column>
        <el-table-column prop="value" :label="$t('valor')" align="right">
          <template slot-scope="scope">
            R$ {{ scope.row.value.toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="quantity"
          align="center"
          :label="$t('quantidade')"
        ></el-table-column>
        <el-table-column label="%" width="180">
          <template slot-scope="scope">
            <el-progress
              :text-inside="true"
              :stroke-width="26"
              :status="scope.row.perc"
              :percentage="scope.row.perc"
            ></el-progress>
          </template>
        </el-table-column>
      </el-table>
    </card>
  </div>
</template>
<script>
import { DashboardFinancialService } from "@/services/customers/dashboard.financial.services";
import moment from "moment";
import "moment/locale/pt-br";

export default {
  name: "BillingServiceDash",
  data() {
    return {
      month: "",
      loading: false,
      options: [],
      tableData: [],
    };
  },
  methods: {
    initBigChart() {
      const vm = this;
      vm.loading = true;
      DashboardFinancialService.services(vm.month)
        .then((response) => {
          vm.tableData = response;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
            duration: 5000,
          });
        })
        .finally(() => (vm.loading = false));
    },
  },
  mounted() {
    const vm = this;
    moment.locale("pt-br");
    const today = moment();
    vm.month = today.format("YYYY-MM");
    for (let i = 0; i < 6; i++) {
      vm.options.push({
        key: today.format("YYYY-MM"),
        label: `${today.format("MMM").toUpperCase()}/${today.format("YYYY")}`,
      });
      today.subtract(1, "month");
    }
    vm.initBigChart(0);
  },
};
</script>
